import { combineReducers } from "redux";
import listReducer from "./listReducer";
import rumbleStateReducer from "./rumbleStateReducer";
import userReducer from "./userReducer";

export default combineReducers({ list: listReducer, rumbleState: rumbleStateReducer, userStatus: userReducer });